module.exports = __webpack_public_path__ + "static/media/pps.1b7dc3e1.svg";